/* eslint-disable max-len */
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { Container } from './styles';
import logo from '../../assets/images/Logo.svg';
import FormGroup from '../../components/FormGroup';
import Input from '../../components/Input';
import { ButtonContainer } from '../../components/Form';
import Button from '../../components/Button';

import Transitions from '../../components/Transition';
import useValidateRegister from './useValidateRegister';
import userShield from '../../assets/images/icons/userShield.svg';

export default function ValidateRegister() {
  const {
    isLoading,
    accessCode,
    handleAccessCodeChange,
    validateRegister,
  } = useValidateRegister();

  return (
    <Transitions>
      <Loader isLoading={isLoading} />
      <Container>
        <div className="asideGif">
          <img src={userShield} alt="busGif" />
        </div>

        <div className="asideLogin">
          <div className="loginTitle">
            <div className="labelTitle">
              <div>
                Valide o seu cadastro
              </div>
              <div className="subtitle">
                Por favor, informe o código de acesso enviado ao seu e-mail para validar o seu cadastro em nosso sistema
              </div>
            </div>
            <img src={logo} alt="logo" className="logo" />
          </div>

          <div className="loginForm">
            <div className="loginInput">
              <FormGroup>
                <label htmlFor="login">Código de acesso</label>
                <Input
                  maxLength={15}
                  placeholder="Insira aqui o código de acesso enviado ao seu e-mail"
                  value={accessCode}
                  onChange={handleAccessCodeChange}
                  autoComplete="new-password"
                />
              </FormGroup>
            </div>
          </div>

          <ButtonContainer flexDirection='column'>
            <Button type="button" onClick={validateRegister} disabled={accessCode.length < 5}>
              Validar Acesso
            </Button>
            <div className="backToLogin">
              <Link to="/">Voltar para a página de login</Link>
            </div>
          </ButtonContainer>
        </div>
      </Container>
    </Transitions>
  );
}
